'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PortalIdParser from 'PortalIdParser';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class CloneOrConvertNotAllowedModal extends Component {
  render() {
    const {
      onClose,
      action
    } = this.props;
    return /*#__PURE__*/_jsxs(UIModal, {
      size: "auto",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onClose
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `EmailComponents.modals.cloneOrConvertNotAllowed.${action}.header`
          })
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `EmailComponents.modals.cloneOrConvertNotAllowed.${action}.body`
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          href: `/browse/${PortalIdParser.get()}/compare/marketing?product=pro`,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "EmailComponents.modals.cloneOrConvertNotAllowed.upgrade"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onClose,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "EmailComponents.modals.cloneOrConvertNotAllowed.close"
          })
        })]
      })]
    });
  }
}
CloneOrConvertNotAllowedModal.propTypes = {
  action: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};